import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { CheckClockLoadService } from '../../services/check-clock-load.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-read-check-clock',
    templateUrl: './read-check-clock.component.html',
    styleUrls: ['./read-check-clock.component.css', '../../app.component.css']
})

export class ReadCheckClockComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    checkClockLoads: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Fecha carga', className: 'center', name: 'name', sort: 'desc' },
        { title: 'Carga desde', className: 'center', name: 'sinceDate' },
        { title: 'Hasta', className: 'center', name: 'untilDate' },
        { title: 'Cant. empleados', className: 'center', name: 'employeeNumber' },
        { title: 'Cant. registros', className: 'center',  name: 'registerNumber' }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' }
    };

    pickadateParams = Utils.pickadateParamsNoBlank();

    since: any;
    until: any;

    globalActions = new EventEmitter<string|MaterializeAction>();

    sinceInit: string;
    untilInit: string;

    gcclsSubs: any;

    permissions = [];
    permissionsSubs: any;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: CheckClockLoadService,
        private authService: AuthService,
        private permissionService: PermissionService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        const currentDate = new Date();
        this.untilInit = currentDate.toISOString().substr(0, 10);
        this.until = this.untilInit;

        currentDate.setMonth(currentDate.getMonth() - 1);
        this.sinceInit = currentDate.toISOString().substr(0, 10);
        this.since = this.sinceInit;


        this.loadCheckClockLoads();
    }

    ngOnInit() {

    }

    loadCheckClockLoads() {
        const sinceDate = Utils.convertDatefromISOStringtoObject(this.since);
        const untilDate = Utils.convertDatefromISOStringtoObject(this.until);
        untilDate.setDate(untilDate.getDate() + 1);

        if (sinceDate < untilDate) {
            this.gcclsSubs = this.service.getCheckClockLoadsSearch(sinceDate, untilDate).subscribe(tempCheckClockLoads => {
                this.gcclsSubs.unsubscribe();

                this.checkClockLoads = [];

                for (const idx in tempCheckClockLoads) {
                    tempCheckClockLoads[idx].name = Utils.getDateWhitoutTime(tempCheckClockLoads[idx].loadDate);
                    tempCheckClockLoads[idx].sinceDate = Utils.getDateWhitoutTime(tempCheckClockLoads[idx].sinceDate);
                    tempCheckClockLoads[idx].untilDate = Utils.getDateWhitoutTime(tempCheckClockLoads[idx].untilDate);

                    this.checkClockLoads.push(tempCheckClockLoads[idx]);
                }

                this.data = this.checkClockLoads;
                this.length = this.data.length;
                this.onChangeTable(this.config);
            });
        } else {
            this.until = this.untilInit;
            this.since = this.sinceInit;

            this.triggerErrorDatesToast();
        }
    }

    onCellClick(data: any): any {
        this.router.navigate([
            '/vw_check_clock/' + data.row.id$,
            {outlets: {'tab_registered_employees': ['registered_employees'], 'tab_unregistered_employees': ['unregistered_employees']}}
        ]);
    }

    onCreate(){
      if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
      this.router.navigate(['/add_check_clock']);
    }

    filterByDates() {
        this.loadCheckClockLoads();
    }

    triggerErrorDatesToast() {
        this.globalActions.emit('toast');
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}

